import { render, staticRenderFns } from "./GayrimenkulHacziForm.vue?vue&type=template&id=1ca7d6ca"
import script from "./GayrimenkulHacziForm.vue?vue&type=script&lang=ts"
export * from "./GayrimenkulHacziForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports